import React, { useState } from "react";
import { elakayAutoText } from "../../pageInside/dataElakay";
import { getTargetProfilesForRole } from "./targetProfiles";

const COLLAPSED_COUNT = 8;

// "Ideal for" / "who can become a {role}?" -- customer-facing marketing personas (ticket
// §8-§13), never a backend role or permission (targetProfiles.js). A profile can belong to more
// than one role's list (ticket §10/§34: e.g. Artisan fits both Seller and Provider), so this just
// renders whatever the shared catalog returns for this one role. Expands in place -- no modal, no
// navigation (ticket §9) -- and is purely data-driven, so a future profile is a one-line addition
// to targetProfiles.js with zero changes here (ticket §32).
const RoleTargetProfiles = ({ plan }) => {
  const [expanded, setExpanded] = useState(false);
  const profiles = getTargetProfilesForRole(plan.id);
  if (profiles.length === 0) return null;

  const visibleProfiles = expanded ? profiles : profiles.slice(0, COLLAPSED_COUNT);
  const hasMore = profiles.length > COLLAPSED_COUNT;

  return (
    <div className="userstep-target-profiles">
      <div className="userstep-target-profiles-label">{elakayAutoText("h_userstep_ideal_for", "Ideal for")}</div>
      <div className="userstep-target-profiles-badges">
        {visibleProfiles.map((profile) => (
          <span key={profile.id} className="userstep-chip userstep-target-profile-chip">
            {elakayAutoText(`h_userstep_target_${profile.id}`, profile.label)}
          </span>
        ))}
        {hasMore && (
          <button
            type="button"
            className="userstep-target-profiles-viewall"
            aria-expanded={expanded}
            onClick={() => setExpanded((current) => !current)}
          >
            {expanded
              ? elakayAutoText("h_userstep_view_fewer_profiles", "Show less")
              : elakayAutoText("h_userstep_view_all_profiles", "View all profiles")}
          </button>
        )}
      </div>
    </div>
  );
};

export default RoleTargetProfiles;
